import { createFileRoute, redirect } from "@tanstack/react-router";

// A gestão de acessos da plataforma agora fica no painel (/admin/plataforma), com o login do painel.
export const Route = createFileRoute("/plataforma/admin")({
  beforeLoad: () => {
    throw redirect({ to: "/admin/plataforma", replace: true });
  },
});
